import type { StoreCustomer } from "@medusajs/types";

export type Customer = StoreCustomer;

export type Session = {
  customer: Customer | null;
};

export const ANONYMOUS_SESSION: Session = { customer: null };
